
    },
    mounted() {<template>
  <div class="main_stock chart">
    <div class="cont_tit">

      <div class="cont_tit_txt">세트별 품목 재고</div>

      <div class="cont_tit_select">
        <img src="../../../assets/img/admin/etners-web/place_check.png">사업장 선택
        <div class="kendo_ui">
          <kendo-dropdownlist
            ref="businessPlaceRef"
            id="businessPlace"
            :data-source="this.$store.state.gewCodeStore.search.combobox.businessPlace.data"
            :data-text-field="'cdNm'"
            :data-value-field="'cdNameSpace'"
            v-bind:style="'width: 100%;height:100%'"
            @change="commonOnChangeEvent"
          >
          </kendo-dropdownlist>
        </div>
      </div>
    </div>

    <div class="main_stock_cont">
      <ul class="main_stock_tab">
        <li v-for="(set,key) in setItem" :class="checkFirstTab(key)" style="cursor: pointer" :id="set.setNo"
            name="stock_tab">
          <a @click="clickSet(key)">{{set.setName}}</a>
        </li>

      </ul>
      <kendo-datasource ref="datasource"
                        :data="computedDataSource"
                        :group-field="'category'">
      </kendo-datasource>
      <div class="main_stock_chart">


        <kendo-chart :data-source-ref="'datasource'"
                     :legend-visible="false"
                     :series-defaults-type="'column'"
                     :series="series"
                     :category-axis="categoryAxis"
                     :value-axis="valueAxis"
                     :tooltip="tooltip"
                     :theme="'sass'"
        ></kendo-chart>

      </div>

    </div>
  </div>

</template>

<script>

  import ApiConfig from '@/api/api.config'
  import ApiUtil from '@/api/api.util'
  import '@babel/polyfill'
  import EtnersCommonUtil from "../../../common/etners.common.util";
  import EtnersChartCommonUtil from '../../../common/admin/chart/etners.admin.chart.util'


  const gewApiDomain = 'https://dsoffice-api.etnersplatform.com/'
  export default {
    name: 'MainStockView',
    data: function () {

      return {
        dataSourceArray: [
          {value: 0, category: 'Two', title: '재고현황', color: '#0054a6'}
        ],
        clickIdx: 0,
        series: [{
          field: 'value',
          name: "#: group.items[0].title #"
        }],
        valueAxis: [{
          line: {
            visible: false
          },
          minorGridLines: {
            visible: true
          },
          labels: {
            rotation: "auto"
          },
          majorUnit: 5
        }],
        categoryAxis: {
          field: 'itemNameStr',
          majorGridLines: {
            visible: false
          },
          labels: {
            cursor: 'pointer',
            font: '10px Roboto, "Noto Sans KR", "맑은  고딕", "Malgun Gothic", dotum, sans-serif',
            align: 'center'
          },
        },
        tooltip: {
          visible: true,
          template: "#= series.name #: #= value #"
        },
        platformDomain: ApiConfig.platformDomain,
        setItem: [],
        setDetailChart: [],
        allSetItem: [],
        setItemByBusinessPlace: []
      }

    },
    created() {
      setTimeout(() => {
        this.allSetItem = this.getAllSetItemData()
      }, 3000)
    },
    computed: {
      computedDataSource() {
        return this.setItem[this.clickIdx] === undefined || this.setItem[this.clickIdx].chartData === null ? [] : this.setItem[this.clickIdx].chartData
      }
    },
    mounted() {
      const vm = this
      let intervalCnt = 0

      setTimeout(() => {

        setInterval(() => {
          const businessPlaceCd = vm.allSetItem[intervalCnt].businessPlaceCd

          vm.$refs.businessPlaceRef.kendoWidget().value(businessPlaceCd)

          vm.getSetItemDatasForChart(businessPlaceCd)
          //  if( vm.allSetItem[intervalCnt].setIndex !== 0) {
          vm.clickSet(vm.allSetItem[intervalCnt].setIndex)
          // }
          if (intervalCnt < vm.allSetItem.length - 1) {
            intervalCnt++
          } else {
            intervalCnt = 0
          }
        }, 10000)
      }, 100)
    },
    methods: {
      checkFirstTab: function (key) {
        if (key === 0) {
          return 'on'
        } else {
          return ''
        }
      },
      clickSet(idx) {

        this.clickIdx = idx

        let clickSetNo = ''
        const stockTab = document.getElementsByName('stock_tab')
        if (this.setItem[idx] !== undefined && this.setItem[idx] !== '') {
          clickSetNo = this.setItem[idx].setNo

          for (let i = 0; i < stockTab.length; i++) {
            stockTab[i].classList.remove('on')
          }
          setTimeout(() => {
            document.getElementById(clickSetNo).classList.add('on')
          })
        }

      },
      commonOnChangeEvent(ev) {
        const vue = this

        this.getSetItemDatasForChart(ev.sender.value())
        setTimeout(function () {

          vue.clickSet(0)

        }, 200)
      },
      getSetItemDatasForChart(businessPlaceCd) {

        const vue = this


        const setItemDataArray = this.setItemByBusinessPlace[businessPlaceCd]

        setItemDataArray.forEach(setItem => {

          const chartData = []
          const categories = []
          setItem.mainDisplayDetails.forEach(detail => {
            /*   chartData.push({
            value: detail.count,
            category: "count",
            itemCd: detail.itemCd,
            itemName: detail.item.itemNm,
            itemNameStr : detail.item.itemNm.substring(0,10),
            cmpyCd : detail.cmpyCd,
            title: '기준수량',
            color: '#fe5f40',
            seqNo :  detail.seqNo
          })*/
            chartData.push({
              value: detail.countOfFixtures,
              category: "countOfFixtures",
              itemCd: detail.itemCd,
              itemName: detail.item.itemNm,
              itemNameStr: detail.item.itemNm.substring(0, 10),
              cmpyCd: detail.cmpyCd,
              title: '재고현황',
              color: '#0054a6',
              seqNo: detail.seqNo
            })


          })

          setItem.chartData = EtnersCommonUtil.sortArray(chartData, 'seqNo')
          setItem.categories = categories
        })

        this.setItem = EtnersCommonUtil.sortArray(setItemDataArray, 'seqNo')


      },
      getAllSetItemData() {

        const allSetItem = []
        const dataSource = this.$store.state.gewCodeStore.search.combobox.businessPlace.data

        dataSource.forEach((v) => {
          const paramData = {
            loginUserToken: sessionStorage.lutk,
            cmpyCd: JSON.parse(sessionStorage.loginUserData).cmpyCd,
            businessPlaceCd: v.cdNameSpace
          }
          const vue = this

          ApiUtil.post(`${gewApiDomain}/v1/ebmp/gew/setitem/itemListMainDisplayByBusinessPlace.json`, paramData)
            .then((response) => {
              const setItemDataArray = response.data.resultData
              vue.setItemByBusinessPlace[v.cdNameSpace] = setItemDataArray
              let setIndex = 0
              if (setItemDataArray.length === 0) {
                allSetItem.push({businessPlaceCd: v.cdNameSpace, setIndex: setIndex})
              } else {
                setItemDataArray.forEach(setItem => {

                  allSetItem.push({businessPlaceCd: v.cdNameSpace, setIndex: setIndex})
                  setIndex++

                })

              }

            })
        })
        return EtnersCommonUtil.sortArray(allSetItem, 'businessPlaceCd')
      }
    }
  }
</script>
